export const DEFAULTS = {
  accordion: 'data-comp-accordion',
  animation: 'toggle-accordion',
  state: 'data-comp-accordion-state',
  trigger: 'data-comp-accordion-trigger',
};

export const STATES = {
  closed: 'closed',
  closing: 'closing',
  opened: 'opened',
  opening: 'opening',
};
